import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { EmptyState, PageHeader } from 'components';
import RaisedButton from 'material-ui/RaisedButton';
import ReportingCharts from './ReportingCharts';
import * as styles from './Reports.scss';
var ReportsDashboard = (_dec = connect(function (state, props) {
  return {
    organization: state.organization.current,
    reports: state.reporting.reports
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ReportsDashboard, _Component);

  var _super = _createSuper(ReportsDashboard);

  function ReportsDashboard() {
    _classCallCheck(this, ReportsDashboard);

    return _super.apply(this, arguments);
  }

  _createClass(ReportsDashboard, [{
    key: "render",
    value: function render() {
      var _this = this;

      var hasFBPage = this.props.organization.SocialAccounts.filter(function (acct) {
        return acct.platform === 'Facebook page';
      })[0];
      var reports = this.props.reports && this.props.reports[this.props.organization.id] ? this.props.reports[this.props.organization.id] : [];
      var summaryReports = reports.length ? reports.filter(function (r) {
        return r.reportType === 'monthly' && !r.isArchived;
      }) : [];
      var checklistReports = reports.length ? reports.filter(function (r) {
        return r.reportType === 'facebookChecklist' && !r.isArchived;
      }) : [];
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Reports Dashboard"
      }), /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Reports",
        secondary: "Dashboard"
      }), hasFBPage ? /*#__PURE__*/React.createElement(ReportingCharts, null) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Connect Facebook",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/settings/social-accounts"));
        },
        text: "Nothing to see here...until you connect your Facebook page.",
        iconName: "ion-asterisk"
      }), hasFBPage && /*#__PURE__*/React.createElement("div", {
        className: styles.boxWrap
      }, !!summaryReports.length && /*#__PURE__*/React.createElement("div", {
        className: styles.box
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.boxTitle
      }, "Social Media Summary"), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar ".concat(styles.boxIcon)
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.boxBlurb
      }, "Your social media summary reports contain a comprehensive overview of how your ads and posts are performing, as well as insights into your core audience and tips for future posts and ad campaigns."), /*#__PURE__*/React.createElement(RaisedButton, {
        label: "View Summary",
        secondary: true,
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/reports/summary"));
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.box
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.boxTitle
      }, "Recent Posts"), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-commenting-o ".concat(styles.boxIcon)
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.boxBlurb
      }, "See detailed analytics for all of your recent posts."), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "View Recent Posts",
        secondary: true,
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/reports/recent-posts"));
        }
      }))), !!checklistReports.length && /*#__PURE__*/React.createElement("div", {
        className: styles.box
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.boxTitle
      }, "Facebook Facelift Report"), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-facebook-official ".concat(styles.boxIcon)
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.boxBlurb
      }, "A detailed breakdown of what your Facebook page is doing right and where it has room for improvement."), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "View Report",
        secondary: true,
        onClick: function onClick() {
          browserHistory.push("/org/".concat(_this.props.organization.id, "/reports/facebook-facelift/").concat(checklistReports[0].id));
        }
      })))));
    }
  }]);

  return ReportsDashboard;
}(Component)) || _class);
export default ReportsDashboard;